/**
 * =============================================================================
 * newsletter-popup.js 
 * =============================================================================
 * Simple newsletter popup for Naturals and Sense of Scotland
 * =============================================================================
 */
var NewsletterPopup = {
  data: {
    selectors: {
      modal: ".modal-newsletter",
      reject_button: "[data-newsletter-popup-reject]"
    },

    expiry: {
      rejected: 30,
      count: 7,
      submitted: 365
    }
  },

  onReady: function(){
    // Establish whether we can / should show the popup
    var modals = document.querySelectorAll(this.data.selectors.modal);
    var that = this;

    if (modals.length === 0) {
      console.warn('[NewsletterPopup] No modals found in DOM');
      return;
    }

    modals.forEach(function(modal) {
      var modalBlockId = modal.dataset.blockId;
      var triggerCount = parseInt(modal.dataset.triggerCount) || 2;
      var delay = parseFloat(modal.dataset.delay) || 3;
      
      // Set form completion event listener
      var form = modal.querySelector("form");
      if (!form) {
        console.warn('[NewsletterPopup] No form found in modal', modalBlockId);
      } else {
        var formListener = function(e){
          e.preventDefault();
          form.removeEventListener("submit", formListener);
          Cookies.set('np-submitted-' + modalBlockId, true, { expires: that.data.expiry.submitted });
          form.submit();
        }.bind(that);
        form.addEventListener("submit", formListener);
      }

      // Set reject event listener
      var rejectButton = modal.querySelector(that.data.selectors.reject_button);
      if (!rejectButton) {
        console.warn('[NewsletterPopup] No reject button found in modal', modalBlockId);
      } else {
        rejectButton.addEventListener("click", that.onReject.bind(that, modalBlockId));
      }

      // Update and trigger if over view count
      that.updateCount(modalBlockId);
      var currentCount = that.getCount(modalBlockId);

      var modalId = "modal-newsletter-" + modalBlockId;
      var modalElement = document.getElementById(modalId);
      
      if (!modalElement) {
        console.error('[NewsletterPopup] Modal element not found:', modalId);
        return;
      }

      var shouldShowResult = that.shouldShow(modalBlockId, triggerCount);

      if(shouldShowResult) {
        console.log('[NewsletterPopup] Will show modal', modalBlockId, 'after', delay, 'seconds');
        setTimeout(function(){
          try {
            var modalDisplay = new bootstrap.Modal(modalElement, {keyboard: false});
            modalDisplay.show();
            Cookies.set('np-shown-' + modalBlockId, true);
            console.log('[NewsletterPopup] Modal', modalBlockId, 'shown successfully');
          } catch(e) {
            console.error('[NewsletterPopup] Error showing modal', modalBlockId, ':', e);
          }
        }.bind(that), parseInt(delay * 1000));
      }
    });
  },

  /**
   * Determine whether to show the popup
   * 
   * @returns {Boolean}
   */
  shouldShow(modalBlockId, triggerCount) {
    // Check if ANY popup has been shown globally (once any popup is shown, don't show others)
    var anyPopupShown = this.hasAnyPopupBeenShown();
    
    return this.getCount(modalBlockId) >= triggerCount && 
      !this.hasRejected(modalBlockId) &&
      !this.hasShown(modalBlockId) &&
      !this.hasBeenSubmitted(modalBlockId) &&
      !anyPopupShown  // Don't show if any popup has been shown
  },
  
  /**
   * Check if ANY newsletter popup has been shown (global check)
   * 
   * @returns {Boolean}
   */
  hasAnyPopupBeenShown() {
    var allCookies = Cookies.get();
    for (var cookieName in allCookies) {
      if (cookieName.indexOf('np-shown-') === 0) {
        // Found a "shown" cookie for any popup
        return true;
      }
    }
    return false;
  },

  /**
   * Update the view count
   */
  updateCount(modalBlockId) {
    if(Cookies.get('np-count-' + modalBlockId) == undefined){
      Cookies.set('np-count-' + modalBlockId, 1, { expires: this.data.expiry.count });
    } else {
      Cookies.set('np-count-' + modalBlockId, parseInt(Cookies.get('np-count-' + modalBlockId)) + 1, { expires: this.data.expiry.count });
    }
  },

  /**
   * Get the view count
   * 
   * @returns {Integer}
   */
  getCount(modalBlockId) {
    var count = Cookies.get('np-count-' + modalBlockId);
    return count ? parseInt(count) : 0;
  },

  /**
   * Set a cookie to mark the prompt as rejected.
   */
  onReject(modalBlockId) {
    Cookies.set('np-rejected-' + modalBlockId, true, { expires: this.data.expiry.rejected });
  },

  /**
   * Get whether the prompt has previously been rejected
   * 
   * @returns {Boolean} whether the prompt has been rejected
   */
  hasRejected(modalBlockId) {
    return Cookies.get('np-rejected-' + modalBlockId) !== undefined;
  },

  /**
   * Get whether the prompt has previously been shown
   * 
   * @returns {Boolean} whether the prompt has been shown
   */
  hasShown(modalBlockId) {
    return Cookies.get('np-shown-' + modalBlockId) !== undefined;
  },

  /**
   * Get whether the prompt form has previously been submitted
   * 
   * @returns {Boolean} whether the prompt form has been submitted
   */
  hasBeenSubmitted(modalBlockId) {
    return Cookies.get('np-submitted-' + modalBlockId) !== undefined;
  },

  /**
   * Reset all cookies for a specific modal (useful for testing)
   * 
   * @param {String} modalBlockId - The block ID of the modal
   */
  reset(modalBlockId) {
    Cookies.remove('np-count-' + modalBlockId);
    Cookies.remove('np-rejected-' + modalBlockId);
    Cookies.remove('np-shown-' + modalBlockId);
    Cookies.remove('np-submitted-' + modalBlockId);
    console.log('[NewsletterPopup] Reset all cookies for modal:', modalBlockId);
  },

  /**
   * Reset all newsletter popup cookies (useful for testing)
   */
  resetAll() {
    var allCookies = Cookies.get();
    for (var cookieName in allCookies) {
      if (cookieName.indexOf('np-') === 0) {
        Cookies.remove(cookieName);
      }
    }
    console.log('[NewsletterPopup] Reset all newsletter popup cookies');
  },
  
  /**
   * Check if any popup has been shown (for debugging)
   */
  checkAnyPopupShown() {
    return this.hasAnyPopupBeenShown();
  }
};

module.exports = NewsletterPopup; 